import { useQuery } from '@tanstack/react-query';

import getNewPresets from '@/requests/library/getNewPresets';

import type { LibrarySection } from '@/types';

const useNewPresetsQuery = (enabled = true) => {
  return useQuery<LibrarySection[] | null, Error, LibrarySection | null>({
    queryKey: ['new-presets'],
    queryFn: getNewPresets,
    select: (sections) => sections?.[0] ?? null,
    enabled,
    gcTime: 10 * 60 * 1000,
  });
};

export default useNewPresetsQuery;
